import { Component, Input, SimpleChanges } from "@angular/core";
import { Constants } from "../../providers";
import { ActuatorService } from "../../providers/api/actuator.service";
import { Node } from "../../models/node.model";
import { AlertController } from "ionic-angular";
import { NodeService } from "../../providers/api/node.service";
import { TranslateService } from "@ngx-translate/core";
import { CacheService } from "ionic-cache";

@Component({
  selector: "node-actuator",
  templateUrl: "node-actuator.html",
})
export class NodeActuatorComponent {
  public device: any;
  public endpoints: any[];
  public transducers: any[];

  public TYPE_NODE: any = Constants.TYPE_NODE;

  public realTimeData: Node;
  public updatedName: any = null;
  public updatedNotification: any = null;
  /*
   * Strings variables used to set text translations
   */
  public cancelButtonString: string;
  public endpointNameEdit: string;
  public updateButtonString: string;
  public updateEndpointTitleString: string;

  @Input() name: any;
  @Input() data: Node;
  @Input() status: string;

  constructor(
    private actuatorService: ActuatorService,
    private alertCtrl: AlertController,
    private nodeService: NodeService,
    private cacheService: CacheService,
    public translateService: TranslateService
  ) {
    this.translateService
      .get([
        "CANCEL_BUTTON",
        "PLEASE_CHOOSE_ENDPOINT_NAME",
        "UPDATE_ENDPOINT_TITLE",
        "UPDATE_BUTTON",
      ])
      .subscribe((values) => {
        this.cancelButtonString = values["CANCEL_BUTTON"];
        this.endpointNameEdit = values["PLEASE_CHOOSE_ENDPOINT_NAME"];
        this.updateEndpointTitleString = values["UPDATE_ENDPOINT_TITLE"];
        this.updateButtonString = values["UPDATE_BUTTON"];
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      if (changes.data.currentValue) {
        this.device = changes.data.currentValue;
        if (this.device.scheme) {
          this.transducers = [
            ...this.device.scheme.endpoints.filter(
              (item) => item.dir === "input"
            ),
          ];
          this.endpoints = [
            ...this.device.scheme.endpoints.filter(
              (item) => item.dir !== "input"
            ),
          ];
        }
      }
    }
  }

  ngOnInit() {}

  updateNotification(data) {
    let index = this.device.scheme.endpoints.findIndex(
      (item) => item._id == data.endpoint
    );
    this.device.scheme.endpoints[index].mobile_notification =
      data.currentNotifications;

    this.nodeService.update(this.device._id, this.device).subscribe(
      (data) => {
        this.updatedNotification = data;
      },
      (err) => {
        console.warn("failed to update!!");
      }
    );
  }

  updateName(data) {
    let alert = this.alertCtrl.create({
      title: this.updateEndpointTitleString,
      inputs: [
        {
          name: "endpointName",
          placeholder: data.currentName,
        },
      ],
      buttons: [
        { text: this.cancelButtonString },
        {
          text: this.updateButtonString,
          handler: (value) => {
            if (value.endpointName !== "") {
              this.nodeService.show(this.device._id).subscribe((node: any) => {
                //Update  device
                let index = node.scheme.endpoints.findIndex(
                  (item) => item._id == data.endpoint
                );
                node.scheme.endpoints[index].display_name = value.endpointName;
                const nodeToUpdate = {
                  building: node.building,
                  apartment: node.apartment,
                  organization: node.organization,
                  room: node.room,
                  "scheme.endpoints": node.scheme.endpoints,
                };

                this.nodeService
                  .update(this.device._id, nodeToUpdate)
                  .subscribe(
                    (response) => {
                      this.cacheService.clearAll();
                      data.currentName = value.endpointName;
                      this.updatedName = data;
                    },
                    (err) => {
                      console.warn("endpoint no updated!!");
                    }
                  );
              });
            } else {
              alert.setMessage(this.endpointNameEdit);
              return false;
            }
          },
        },
      ],
    });
    alert.present();
  }

  updateEndpoint(params) {
    const isDali = params.device.scheme
      ? params.device.scheme.code === "010005"
      : false;
    if (params.device._id && typeof params.device !== "string") {
      params = {
        ...params,
        device: params.device._id,
      };
    }
    this.actuatorService.create(params, isDali).subscribe(
      (res) => {
        this.cacheService.clearAll();
        if (res !== false && isDali) {
          this.actuatorService.release();
        }
      },
      (err) => {
        console.error("Update error:::", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/node-actuator/node-actuator.ts